export var EFixingDetails;
(function (EFixingDetails) {
    EFixingDetails["Initial"] = "1";
    EFixingDetails["Final"] = "2";
})(EFixingDetails || (EFixingDetails = {}));
